// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3mfVy","footer":"ChangeClinic_footer__3F_03"};